// @mui material components
// import Icon from '@mui/material/Icon';
// import Edit from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import SecurityIcon from '@mui/icons-material/Security';
import LogoutIcon from '@mui/icons-material/Logout';
import SensorsIcon from '@mui/icons-material/Sensors';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { SvgIcon } from '@mui/material';
import { ReactComponent as ControllerBoxIcon } from 'assets/images/icons/controller-box.svg';

//  React components
import MDBox from 'components/MDBox';
//  React context
import { setOpenConfigurator, useMaterialUIController } from 'context';
// Custom styles for the Configurator
import ConfiguratorRoot from 'examples/Configurator/ConfiguratorRoot';
// react-github-btn
import { useSelector } from 'react-redux';
// Import useTokenManager
import useTokenManager from '../../hooks/useTokenManager';
import DefaultNavbarLink from '../Navbars/DefaultNavbar/DefaultNavbarLink';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const CONFIGURATOR_Z_INDEX = 30002;

function Configurator() {
  const [controller, dispatch] = useMaterialUIController();
  const { openConfigurator, darkMode } = controller;

  // Get logout function from useTokenManager
  const { logout } = useTokenManager();

  const handleCloseConfigurator = () => setOpenConfigurator(dispatch, false);

  // Handle logout click
  const handleLogout = () => {
    logout();
  };

  const currentUser = useSelector(state => state.sensors.currentUser);

  return (
    <ConfiguratorRoot
      variant="permanent"
      ownerState={{ openConfigurator }}
      sx={{
        zIndex: CONFIGURATOR_Z_INDEX,
        '& .MuiDrawer-paper': {
          zIndex: CONFIGURATOR_Z_INDEX,
        },
      }}>
      <MDBox
        display="flex"
        flex
        justifyContent="space-between"
        alignItems="baseline"
        flexDirection="column"
        pt={4}
        pb={0.5}
        px={3}>
        {/* Common links for all users */}
        <DefaultNavbarLink icon={<PersonIcon />} name="My Profile" route="/manage-users/me" />

        <DefaultNavbarLink icon={<SensorsIcon />} name="Manage Sensors" route="/manage-sensors/" />

        <DefaultNavbarLink
          icon={<SvgIcon component={ControllerBoxIcon} inheritViewBox />}
          name="Manage Controllers"
          route="/manage-controllers/"
        />

        <DefaultNavbarLink icon={<ApartmentIcon />} name="Manage Buildings" route="/manage-buildings/" />

        <DefaultNavbarLink icon={<CalendarMonthIcon />} name="Manage Schedules" route="/manage-schedules/" />

        {/* Admin/Distributor only links */}
        {currentUser?.role !== 'c' && (
          <>
            <DefaultNavbarLink icon={<PeopleAltIcon />} name="Manage Users" route="/manage-users/" />
            <DefaultNavbarLink icon={<SecurityIcon />} name="Users Permissions" route="/manage-permissions/users" />
          </>
        )}

        {/* Admin only links */}
        {currentUser?.role === 's' && (
          <>
            <DefaultNavbarLink icon={<SecurityIcon />} name="Devices Permissions" route="/manage-permissions/devices" />
            <DefaultNavbarLink icon={<AdminPanelSettingsIcon />} name="Admin Center" route="/admin-center/" />
          </>
        )}

        {/* Logout link - now calls the actual logout function */}
        <DefaultNavbarLink icon={<LogoutIcon />} name="Log Out" onClick={handleLogout} route="/authentication/sign-in" />

        <CloseIcon
          sx={({ typography: { size }, palette: { dark, white } }) => ({
            fontSize: `${size.lg} !important`,
            color: darkMode ? white.main : dark.main,
            stroke: 'currentColor',
            strokeWidth: '2px',
            cursor: 'pointer',
            transform: 'translateY(5px)',
          })}
          style={{ position: 'absolute', right: '20px' }}
          onClick={handleCloseConfigurator}>
          close
        </CloseIcon>
      </MDBox>
    </ConfiguratorRoot>
  );
}

export default Configurator;
